import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2019() {
  const handleDownload1 = () => {
    window.open("assets/2019/Debasish Paul.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2019/Lalhriatpuii & Joseph Lalremsanga.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open("assets/2019/Vanlalhumi & LS Sharma.pdf", "_blank");
  };
  const handleDownload4 = () => {
    window.open("assets/2019/Abdul Hannan Barbhuiya.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2019/Lalchhuanmawia.pdf", "_blank");
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 2, No. 1 (2019)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Inclusive growth and human development : A review
                </div>
                <div className="text-sm text-green-600">Debasish Paul</div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Consumption pattern of MNREGA beneficiaries in Tlangnuam RD
                  block, Mizoram
                </div>
                <div className="text-sm text-green-600">
                  Lalhriatpuii & Joseph Lalremsanga
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Horticulture farming as a sustainable source of income for
                  Mizo farmers: A case study of grape farmers in Champhai
                  district
                </div>
                <div className="text-sm text-green-600">
                  Vanlalhumi & LS. Sharma
                </div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Private cost of higher education in Mizoram: An Economic
                  Analysis
                </div>
                <div className="text-sm text-green-600">
                  Abdul Hannan Barbhuiya
                </div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Economics of arecanut production in Mizoram
                </div>
                <div className="text-sm text-green-600">Lalchhuanmawia</div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
